import ga from '../../../utils/gaConnect';
import { Trans, useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import {
  DIALOG_TYPE,
  DOCUMENT_TYPE,
  DOC_FORMAT_CONFIG_VALUES,
  EDIT_FROM,
  MAX_OPEN_FILE_SIZE,
  PRODUCT_TYPE,
  URLS
} from '../../../define/global';
import mobileBackgroundImg from '../../../img/bg_pattern.png';
import iconMobileLogo from '../../../img/logo_mobile.png';
import iconMobileLogo2X from '../../../img/logo_mobile@2x.png';
import NaverWorksIcon from '../../../img/ico_works_24.png';
import NaverWorksIcon2x from '../../../img/ico_works_24@2x.png';
import { useAppDataSliceSelector } from '../../../store/modules/appData';
import { movePOClientDownloadURL } from '../../../utils/util';
import Button from '../../common/Button';
import FileButton from '../../common/FileButton';
import { FIXED_AD_ID } from '../../common/FixedAD';
import MobileBottomAD from '../../common/mobile/MobileBottomAD';
import Dialog from '../Dialog';
import UAParser from 'ua-parser-js';
import { useEffect, useState } from 'react';
import FloatingHomeButtonMobile from './FloatingHomeButtonMobile';
import { useNaverWorksDataSliceSelector } from '../../../store/modules/naverWorksData';
import { useDispatch } from 'react-redux';
import { getNaverWorksTokenInfo, reauthorizationNaverWorks } from '../../../extApis/naverWorksApi';
import { openDialog } from '../../../store/modules/dialog';
import { NaverWorksError } from '../../../errors';
import { useWhaleSpaceDataSliceSelector } from '../../../store/modules/whaleSpaceData';

const DialogMobileBody = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(${mobileBackgroundImg});
  box-sizing: border-box;
  /* @media (orientation: portrait) {
  width: 150px;
  height: 200px;
}
@media (orientation: landscape) {
  width: 300px;
  height: 200px;
} */
`;

const MobilePopupContents = styled.div`
  @media (orientation: portrait) {
    width: 340px;
    height: 366px;
    padding: 0 10px;
  }
  @media (orientation: landscape) {
    width: 412px;
    height: 220px;
  }

  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`;

const MobilePOLogo = styled.img`
  width: 252px;
  height: 39px;
  @media (orientation: portrait) {
    margin-bottom: 36px;
  }
  @media (orientation: landscape) {
    margin-bottom: 18px;
  }
`;

const MobileDescription = styled.span`
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: #464646;
`;

const MobileButtonArea = styled.div`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  @media (orientation: portrait) {
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
  }
  @media (orientation: landscape) {
    align-items: center;
    justify-content: center;
    padding: 0px 10px;
    margin-top: 18px;
    gap: 8px;
  }
`;

const WarningDescriptionArea = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  box-sizing: border-box;

  @media (orientation: portrait) {
    margin-top: 6px;
  }
  @media (orientation: landscape) {
    margin-top: 5px;
    padding: 0px 10px;
  }
`;

const WarningDescription = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  border-radius: 2px;
  border: solid 1px #f46060;
  box-sizing: border-box;
  padding: 7px 6px;

  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #ff0d0d;
`;

const MobileSubDescriptionList = styled.ul`
  @media (orientation: landscape) {
    display: none;
  }
  margin: 0;
  margin-top: 11px;
  padding-left: 15px;
  box-sizing: border-box;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #96999c;
`;
const MobileSubDescriptionItem = styled.li``;
const MobileSubDescriptionItemText = styled.span`
  position: relative;
  left: -3px;
`;

const MobileBottomPrivacyWrapper = styled.div`
  position: absolute;
  left: 0px;
  bottom: 66px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  color: #464646;
`;

const MobileBottomTerms = styled.div`
  cursor: pointer;
`;

const MobileBottomPrivacy = styled.div`
  cursor: pointer;
  margin-left: 16px;
  margin-right: 24px;
`;

const MobileBottomCopyright = styled.div``;

const MobileBottomADWrapper = styled.div`
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
`;

const MobileButtonCss = css`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  @media (orientation: portrait) {
    width: 100%;
    height: 39px;
    margin-bottom: 14px;
  }
  @media (orientation: landscape) {
    width: 100%;
    height: 40px;
    margin-bottom: 14px;
  }
`;

const NaverWorksButtonCss = css`
  ${MobileButtonCss}
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const NaverWorksCloudIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 8px;
`;

const NaverWorksBIText = styled.div`
  font-size: 14px;
  color: #3bc65a;
  margin-right: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HwpMobileButtonCss = css`
  ${MobileButtonCss}
  background-color: #1d7ff9;
  color: white;
  border: none;
`;

const SheetMobileButtonCss = css`
  ${MobileButtonCss}
  background-color: #51b41b;
  color: white;
  border: none;
`;

const SlideMobileButtonCss = css`
  ${MobileButtonCss}
  background-color: #fd8900;
  color: white;
  border: none;
`;

export default function OpenDocumentDialogMobile({ onFilePCOpen }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const appData = useAppDataSliceSelector();
  const naverWorksDataSlice = useNaverWorksDataSliceSelector();
  const whaleSpaceDataSlice = useWhaleSpaceDataSliceSelector();
  const isB2C =
    appData.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE &&
    appData.productType !== PRODUCT_TYPE.WITH_URL_OPENER_B2B;

  const [isFacebook, setIsFaceBook] = useState(false);

  useEffect(() => {
    const parser = new UAParser();
    const __isFaceBook = parser.getBrowser().name === 'Facebook' ? true : false;
    setIsFaceBook(__isFaceBook);
  }, []);

  const getButtonCss = () => {
    switch (DOC_FORMAT_CONFIG_VALUES.sdk.documnetType) {
      case DOCUMENT_TYPE.SHEET:
        return SheetMobileButtonCss;
      case DOCUMENT_TYPE.SLIDE:
        return SlideMobileButtonCss;
      case DOCUMENT_TYPE.HWP:
      case DOCUMENT_TYPE.WORD:
      default:
        return HwpMobileButtonCss;
    }
  };
  const buttonCss = getButtonCss();

  const onClickOpenNaverWorks = async () => {
    try {
      const res = await getNaverWorksTokenInfo();
      dispatch(
        openDialog({
          dialogType: DIALOG_TYPE.DIALOG_NAVERWORKS_BROWSER,
          arg: { from: EDIT_FROM.FROM_OPENDIALOG }
        })
      );
    } catch (error) {
      if (error instanceof NaverWorksError && error.code === 401) {
        ga.event({
          category: '웍스드라이브',
          action: '연결하기',
          label: whaleSpaceDataSlice.domain
        });
        reauthorizationNaverWorks({ domain: whaleSpaceDataSlice.domain, isSelf: true });
      } else {
        alert(`Naver Works 문서 열기에 실패했습니다.`);
      }
    }
  };

  return (
    <>
      <Dialog isFullScreen isNoHeader>
        <DialogMobileBody>
          <MobilePopupContents>
            <MobilePOLogo src={iconMobileLogo} srcSet={iconMobileLogo2X} />
            <MobileDescription>
              <Trans
                i18nKey={
                  appData.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE
                    ? 'MobileOpenDocumentDialog.Contents'
                    : 'MobileOpenDocumentDialog.ContentsEduWhale'
                }
              />
            </MobileDescription>
            <MobileButtonArea>
              {appData.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE && (
                <Button
                  cssExt={MobileButtonCss}
                  onClick={() => {
                    ga.event({
                      category: '모바일 앱',
                      action: 'Polaris Office 앱 다운로드',
                      label: '시작화면'
                    });
                    movePOClientDownloadURL({ appData, lang: i18n.language });
                  }}>
                  {t('MobileOpenDocumentDialog.POAppDownload')}
                </Button>
              )}
              <FileButton
                acceptExt={
                  isFacebook
                    ? ''
                    : DOC_FORMAT_CONFIG_VALUES.fullExtList /*Facebook in-app brower 에서 파일탐색기가 안열리는 현상 수정 */
                }
                onChange={onFilePCOpen}
                cssExt={buttonCss}>
                {t('MobileOpenDocumentDialog.OpenLocalFile', {
                  FORMAT: DOC_FORMAT_CONFIG_VALUES.sdk.documnetType
                })}
              </FileButton>
              {appData.productType === PRODUCT_TYPE.WITH_WHALE_SPACE && (
                <Button cssExt={NaverWorksButtonCss} onClick={onClickOpenNaverWorks}>
                  <NaverWorksCloudIcon src={NaverWorksIcon} srcSet={NaverWorksIcon2x} />
                  <NaverWorksBIText>NAVER WORKS</NaverWorksBIText>
                  {naverWorksDataSlice.isConnected ? t('Common.DoOpenDoc') : t('Common.DoConnect')}
                </Button>
              )}
            </MobileButtonArea>
            {isFacebook && (
              <WarningDescriptionArea>
                <WarningDescription>
                  <Trans i18nKey="MobileOpenDocumentDialog.WarningInAppBrowser" />
                </WarningDescription>
              </WarningDescriptionArea>
            )}
            <MobileSubDescriptionList>
              <MobileSubDescriptionItem>
                <MobileSubDescriptionItemText>
                  {t('MobileOpenDocumentDialog.LimitFileSize', {
                    MAX_OPEN_FILE_SIZE: MAX_OPEN_FILE_SIZE
                  })}
                </MobileSubDescriptionItemText>
              </MobileSubDescriptionItem>
              <MobileSubDescriptionItem>
                <MobileSubDescriptionItemText>
                  <Trans i18nKey="MobileOpenDocumentDialog.OptimizationPC" />
                </MobileSubDescriptionItemText>
              </MobileSubDescriptionItem>
            </MobileSubDescriptionList>
          </MobilePopupContents>
        </DialogMobileBody>
        {isB2C && (
          <MobileBottomPrivacyWrapper>
            <MobileBottomTerms
              onClick={() => window.open(URLS.TERMS, '_blank', 'noopener,noreferrer')}>
              {t('FileMenu.Terms')}
            </MobileBottomTerms>
            <MobileBottomPrivacy
              onClick={() => window.open(URLS.PRIVACY, '_blank', 'noopener,noreferrer')}>
              {t('FileMenu.Privacy')}
            </MobileBottomPrivacy>
            <MobileBottomCopyright>{t('MobileOpenDocumentDialog.Copyright')}</MobileBottomCopyright>
          </MobileBottomPrivacyWrapper>
        )}
        {appData.viewAD && (
          <MobileBottomADWrapper>
            <MobileBottomAD id={FIXED_AD_ID.IN_MOBILE_OPEN_DOCUMENT_DIALOG} />
          </MobileBottomADWrapper>
        )}
        <FloatingHomeButtonMobile />
      </Dialog>
    </>
  );
}
